import Clock from '../../../pages/ControlSheet/assets/clock.svg'
import ArrowRight from '../assets/arrow-right.svg'

import styles from './DutyTooltip.module.scss'
import { ControlSheetTrip } from '../types/types'
import { ControlSheetNotesViewer } from './ControlSheetNotesViewer'
import { convertMinutesToHoursMinutes } from '../helpers/convertMinutesToHoursMinutes'
import { displayTime } from '../helpers/displayTime'
import { AnnotationsPermission } from '@/pages/ControlSheet/ui/ControlSheetPage'
import clsx from 'clsx'

interface DutyTooltipProps {
    route: string
    trip: ControlSheetTrip
    annotationsPermission: AnnotationsPermission
}

export const DutyTooltip = (props: DutyTooltipProps) => {
    const route = props.route
    const {
        duty,
        isNearDrivingHours,
        tripBeforeBreak,
        reliefStartTime,
        reliefTimeMins,
        tripAfterBreak,
        reliefEndTime,
        lastTrip,
        timeOnDuty,
    } = props.trip
    const shiftEndTime = props.trip.shiftEnd
    const drivingHours = props.trip.totalDrivingMinutesOnDuty
    const currentSpell = props.trip.spellTime
    const spellNearDrivingHours = currentSpell >= 240
    const existingNotes = props.annotationsPermission !== 'none' ? props.trip.annotations.flatMap((a) => a.notes) : []

    const routeAfterBreak = props.trip.routeAfterBreak && props.trip.routeAfterBreak !== route

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.dutyContainer}>
                    Duty
                    <span className={styles.dutyNumber}>{duty}</span>
                </div>
                {isNearDrivingHours && (
                    <div className={styles.nearDrivingHours}>
                        <Clock />
                        <span>Near Driving Hours</span>
                    </div>
                )}
            </div>
            <div className={styles.body}>
                <div className={styles.bodyItem}>
                    <div className={styles.bodyItemTitle}>Relief</div>
                    <div className={styles.bodyItemValue}>
                        <span className={clsx(styles.highlightContainer, styles.mealReliefContainer)}>
                            Trip {tripBeforeBreak}, {displayTime(reliefStartTime)} ({reliefTimeMins} min)
                        </span>
                        <ArrowRight />
                        <span>
                            Trip {tripAfterBreak}, {displayTime(reliefEndTime)}{' '}
                            {routeAfterBreak && `(Route ${props.trip.routeAfterBreak})`}
                        </span>
                    </div>
                </div>
                <div className={styles.bodyItem}>
                    <div className={styles.bodyItemTitle}>Shift end</div>
                    <div className={styles.bodyItemValue}>
                        <span className={clsx(styles.highlightContainer, styles.shiftEndContainer)}>
                            Trip {lastTrip}, {displayTime(shiftEndTime)}
                        </span>
                    </div>
                </div>
                <div className={styles.bodyItem}>
                    <div className={styles.bodyItemTitle}>Total driving hours</div>
                    <div className={styles.bodyItemValue}>
                        <span className={styles.drivingHours}>
                            {isNearDrivingHours && <Clock />} {convertMinutesToHoursMinutes(drivingHours)}
                        </span>
                    </div>
                </div>
                <div className={styles.bodyItem}>
                    <div className={styles.bodyItemTitle}>Spell hours</div>
                    <div className={styles.bodyItemValue}>
                        <span className={styles.drivingHours}>
                            {spellNearDrivingHours && <Clock />} {convertMinutesToHoursMinutes(currentSpell)}
                        </span>
                    </div>
                </div>

                <div className={styles.bodyItem}>
                    <div className={styles.bodyItemTitle}>Time on duty</div>
                    <div className={styles.bodyItemValue}>{timeOnDuty}</div>
                </div>
            </div>
            <ControlSheetNotesViewer notes={existingNotes} />
        </div>
    )
}
